import { styled } from '@mui/system'
import { Tabs as MuiTabs } from '@mui/material'

const shouldForwardProp = (prop) => !['aboveTheFold'].includes(prop)

const Tabs = styled(MuiTabs, { shouldForwardProp })`
	.MuiTabs-flexContainer {
		justify-content: ${({ alignment }) => {
			switch (alignment) {
				case 'left':
					return 'flex-start'
				case 'center':
					return 'center'
				case 'right':
					return 'flex-end'
			}
		}};
	}
`

export { Tabs }
